import { render, staticRenderFns } from "./DownloadSquareIcon.vue?vue&type=template&id=6a4dfbca&scoped=true"
import script from "./DownloadSquareIcon.vue?vue&type=script&lang=js"
export * from "./DownloadSquareIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4dfbca",
  null
  
)

export default component.exports